import { Datagrid, DateField, EmailField, FunctionField, ReferenceField, ReferenceManyField, Show, SimpleShowLayout, TextField } from "react-admin";
import { Grid, Typography } from "@mui/material";
import { AgentTitle } from "./index";
import StartRequestButtons from "./StartRequestButtons";

const MaskedSSN = () => (
  <FunctionField
    label="SSN"
    render={(record) => {
      if (!record.ssn) return null;
      return record.ssn.length >= 4
        ? `***-**-${record.ssn.slice(-4)}`
        : record.ssn.replace(/./g, "*");
    }}
  />
);

export const AgentShow = () => (
  <Show title={<AgentTitle />}>
    <SimpleShowLayout>
      {/* #57 - principal-only: start a request on this agent's behalf. */}
      <StartRequestButtons />
      <Grid container spacing={4}>
        <Grid item xs={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Agent Information</Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField source="npn" label="NPN" />
            </Grid>
            <Grid item xs={6}>
              <TextField source="advisor" />
            </Grid>
            <Grid item xs={6}>
              <ReferenceField source="agency" reference="agency" label="Agency" emptyText="—" link={false}>
                <TextField source="name" />
              </ReferenceField>
            </Grid>
            <Grid item xs={6}>
              <TextField source="firstName" />
            </Grid>
            <Grid item xs={6}>
              <TextField source="lastName" />
            </Grid>
            <Grid item xs={6}>
              <TextField source="preferredName" />
            </Grid>
            <Grid item xs={6}>
              <DateField source="dob" label="Date of Birth" />
            </Grid>
            {/* #22 — most recent FSD ("who recommended you?") choice. */}
            <Grid item xs={6}>
              <TextField source="fsd" label="FSD (most recent)" emptyText="—" />
            </Grid>
            <Grid item xs={12}>
              <MaskedSSN />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Contact Information</Typography>
            </Grid>
            <Grid item xs={12}>
              <EmailField source="email" />
            </Grid>
            <Grid item xs={12}>
              <EmailField source="commissionEmail" />
            </Grid>
            <Grid item xs={12}>
              <EmailField source="enrollmentEmail" />
            </Grid>
            <Grid item xs={12}>
              <TextField source="phone" />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mt: 2 }}>Address</Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField source="addressStreet" label="Street" />
            </Grid>
            <Grid item xs={6}>
              <TextField source="addressCity" label="City" />
            </Grid>
            <Grid item xs={3}>
              <TextField source="addressState" label="State" />
            </Grid>
            <Grid item xs={3}>
              <TextField source="addressZip" label="Zip" />
            </Grid>
          </Grid>
        </Grid>

        {/* #62 — this agent's contract requests, newest first; row opens the request. */}
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ mt: 2 }}>Contract Requests</Typography>
          <ReferenceManyField
            reference="contract-request"
            target="agent"
            sort={{ field: "createdAt", order: "DESC" }}
            label={false}
          >
            <Datagrid rowClick="edit" bulkActionButtons={false} empty={<Typography variant="body2">No contract requests.</Typography>}>
              <DateField source="createdAt" label="Submitted" />
              <TextField source="requestType" label="Type" />
              <TextField source="status" label="Status" />
              <TextField source="specialistName" label="ACE" emptyText="—" />
            </Datagrid>
          </ReferenceManyField>
        </Grid>
      </Grid>
    </SimpleShowLayout>
  </Show>
);

export default AgentShow;
